module.exports = __webpack_public_path__ + "img/logo.a6c91c47.png";